module.exports = __webpack_public_path__ + "media/views/builder/sites/assets/checkbox_hover-41da66aa8de2d48a75743ef4a562d412.svg";